import { Grid, MenuItem, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react'

import { NavigateFunction, useLocation, useNavigate, useParams } from 'react-router-dom';
import { ReactComponent as AddSquare } from '../../../assets/icons/add-square-green.svg'


import { useTranslation } from 'react-i18next';
import NavigateListCustom from '../../../components/navigation/NavigationListCustom';
import { routeName } from '../../../routes/routeName';
import { ButtonOutlined, ButtonPrimary } from '../../../components/button/ButtonCustoms';
import InputTextField from '../../../components/input/inputTextField';
import UploadFile from '../../../components/upload/UploadFile';
import InputDatePicker from '../../../components/input/inputDatePicker';
import { ExaminationCalendarApi } from '../../../api/examination-calendar/examination-calendar.api';
import { alertError, alertSuccess, swalError, swalSuccess } from '../../../components/alert/swal';
import moment from 'moment';
import { timeToView } from '../../../utils/date.utils';
import { produce } from 'immer';
import TimePickerCustom from '../../../components/time-picker/TimePicker';
import saveAs from 'file-saver';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../store/store';
import { setLoading, unsetLoading } from '../../../store/loading/loading.slice';
const defaultState = {
    id_examination_calendar: 0,
    examination_name: '',
    examination_desc: '',
    examination_start_date: undefined,
    examination_end_date: undefined,
    examination_calendar_start_date: undefined,
    examination_calendar_end_date: undefined,
    examination_calendar_status: "DRAFT",
    id_examination_calendar_files: [
        {
            file: null
        }
    ]
}
export default function AddScheduleCalenda() {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const location = useLocation()
    const pathname = location.pathname;
    const navigate: NavigateFunction = useNavigate();
    const search_params = new URLSearchParams(location.search);
    // const id_Agenda = search_params.get("id");
    const mode = search_params.get("mode");
    const { id } = useParams();
    const api_img = useSelector((state: RootState) => state.api.image_api);
    // console.log(api_img,'api_img')
    // const [listAgendas, setListAgendas] = useState<any[]>([]);

    const [form, setForm] = useState<any>(defaultState);
    // console.log(form, 'form')
    // const handleUpdate = async (files: any, index: number) => {
    //     const formData = new FormData();
    //     files.forEach((file: File) => {
    //         formData.append("files", file);
    //     });
    //     await ExaminationCalendarApi.upload(formData).then((res: any) => {
    //         if (res.status < 300) {

    //             setForm({
    //                 ...form, id_examination_calendar_files: form?.id_examination_calendar_files?.map((item: any, i: number) => {
    //                     return i === index ? res.data[0] : item
    //                 })
    //             })
    //         }
    //     }).catch((error: any) => {
    //         console.log(error)
    //         swalError(error?.response?.data?.message || 'เกิดข้อผิดพลาด')
    //     })
    // }

    const handleChangeFile = (index: number, file: any) => {
        setForm((prev: any) => produce(prev, (draft: any) => {
            draft.id_examination_calendar_files[index].file = file
        }))
    }

    // ลบไฟล์ออกจากรายการ
    // เงื่อนไข API: ตอน submit จะส่งเฉพาะ id ของไฟล์ที่เหลืออยู่ในรายการ
    // ไฟล์ไหนถูกลบออก = ไม่ส่ง id นั้นไป => server จะลบไฟล์นั้นทิ้งให้เอง
    const handleRemoveFile = (index: number) => {
        setForm((prev: any) => produce(prev, (draft: any) => {
            draft.id_examination_calendar_files.splice(index, 1)
            // คงช่องอัปโหลดว่างไว้ 1 ช่องเสมอเมื่อลบจนไม่เหลือไฟล์
            if (draft.id_examination_calendar_files.length === 0) {
                draft.id_examination_calendar_files.push({ file: null })
            }
        }))
    }

    const handleUploadFilePromise = async (files: File[]): Promise<number[]> => {
        try {
            const formData = new FormData();
            files.forEach((file: File) => {
                formData.append("files", file);
            });
            // return []
            return await ExaminationCalendarApi.upload(formData).then((res) => {
                if (res.status < 300) {
                    const file_data: any[] = res.data;
                    return file_data?.map((list) => list?.id_examination_calendar_file) || []
                } else {
                    return [];
                }
            })
        } catch (err) {
            console.log(err)
            return []
        }
    }

    const handleDownloadFile = async (id_examination_calendar_file: number, file_name: string, file_type: string) => {
        try {
            dispatch(setLoading());
            const response = await ExaminationCalendarApi.downloadFile(id_examination_calendar_file);
            saveAs(response.data, file_name)
            dispatch(unsetLoading());
        } catch (err) {
            alertError(t("ดาวน์โหลดไฟล์ไม่สำเร็จ"));
            dispatch(unsetLoading());
        }
    }

    const handleSubmit = async (status: any) => {
        const files_state = (form?.id_examination_calendar_files as any[]) || [];

        // ไฟล์เดิมที่ยังอยู่ในรายการ (มี id อยู่แล้ว) => ส่ง id กลับไปเพื่อ "เก็บไว้"
        const existing_file_ids: number[] = files_state
            .filter((item) => item?.id_examination_calendar_file)
            .map((item) => item.id_examination_calendar_file);

        // ไฟล์ใหม่ที่เพิ่งเลือก (มี file แต่ยังไม่มี id) => อัปโหลดเพื่อรับ id ใหม่
        const new_files: File[] = files_state
            .filter((item) => item?.file && !item?.id_examination_calendar_file)
            .flatMap((item) => item.file);

        let uploaded_file_ids: number[] = [];
        if (new_files.length > 0) {
            uploaded_file_ids = await handleUploadFilePromise(new_files);
        }

        // id ที่ไม่อยู่ใน list นี้ = ไฟล์ที่ถูกลบ => server จะลบทิ้งให้เอง
        const id_files: number[] = [...existing_file_ids, ...uploaded_file_ids];
        const body = {
            examination_name: form?.examination_name || "",
            examination_desc: form?.examination_desc || "",
            examination_start_date: `${moment(form?.examination_start_date).format('YYYY-MM-DD')}T${form?.examination_start_time}` || "",
            examination_end_date: `${moment(form?.examination_end_date).format('YYYY-MM-DD')}T${form?.examination_end_time}` || "",
            examination_calendar_start_date: form?.examination_calendar_start_date || "",
            examination_calendar_end_date: form?.examination_calendar_end_date || "",
            examination_calendar_status: status || form?.examination_calendar_status || "",
            id_examination_calendar_files: id_files
        }
        if (id) {
            await ExaminationCalendarApi.patch(body, id).then((res: any) => {
                if (res.status < 300) {
                    alertSuccess(t('บันทึกปฏิทินตารางการสอบ เรียบร้อยแล้ว'))
                    navigate(routeName.cms.ScheduleCalenda);
                    // handleClose()
                }
            }).catch((error: any) => {
                console.log(error)
                swalError(error?.response?.data?.message || t('เกิดข้อผิดพลาด'))
            })
        } else {
            await ExaminationCalendarApi.post(body).then((res: any) => {
                if (res.status < 300) {
                    alertSuccess(t('เพิ่มปฏิทินตารางการสอบ เรียบร้อยแล้ว'))
                    navigate(routeName.cms.ScheduleCalenda);
                    // handleClose()
                }
            }).catch((error: any) => {
                console.log(error)
                swalError(error?.response?.data?.message || t('เกิดข้อผิดพลาด'))
            })
        }
    }
    const getDetail = async () => {
        await ExaminationCalendarApi.findById(id).then((res: any) => {
            if (res.status < 300) {
                const examination_calendar_files: any[] = res.data.data?.examination_calendar_files || []
                setForm({
                    ...form,
                    ...res.data.data,
                    examination_end_time: timeToView(res.data.data?.examination_end_date),
                    examination_start_time: timeToView(res.data.data?.examination_start_date),
                    id_examination_calendar_files: examination_calendar_files?.length > 0 ? examination_calendar_files : [{ file: null }]
                })
                // loadData()
                // handleClose()
            }
        }).catch((error: any) => {
            console.log(error)
            swalError(error?.response?.data?.message || t('เกิดข้อผิดพลาด'))
        })
    }
    useEffect(() => {
        if (id) {
            getDetail()
        }

    }, [])


    const disabled_draft_button = (!form?.examination_name || !form?.examination_start_date || !form?.examination_start_time || !form?.examination_end_date || !form?.examination_end_time);
    const disabled_submit_button = (!form?.examination_name || !form?.examination_start_date || !form?.examination_start_time || !form?.examination_end_date || !form?.examination_end_time);


    return (
        <div className="h-auto">
            <NavigateListCustom
                navigateData={[
                    {
                        name: t("ปฏิทินตารางการสอบ"),
                        key: "1",
                        pathName: routeName.cms.ScheduleCalenda,
                    },
                    {
                        name: t("เพิ่มปฏิทินตารางการสอบ"),
                        key: "2",
                        pathName: pathname
                    },
                ]}
            />

            {/* header */}
            <section className="my-4">
                <Typography variant="h3">{t("เพิ่มปฏิทินตารางการสอบ")}</Typography>
            </section>

            <section className="my-4">
                <Grid container spacing={2}>
                    <Grid
                        item
                        xs={12}
                        md={12}
                        lg={12}
                        sx={{
                            alignSelf: "end",
                        }}
                    >
                        <InputTextField
                            heading={t('ชื่อ')}
                            placeholder={t('ชื่อ')}
                            required
                            value={form?.examination_name || ''}
                            onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                setForm({ ...form, examination_name: e.target.value })
                            }}
                            helperText={
                                ""
                            }
                            disabled={false}

                        />
                    </Grid>
                    <Grid
                        item
                        xs={12}
                        md={12}
                        lg={12}
                        sx={{
                            alignSelf: "end",
                        }}
                    >
                        <InputTextField
                            heading={t('รายละเอียด')}
                            placeholder={t('รายละเอียด')}
                            value={form?.examination_desc || ''}
                            onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                setForm({ ...form, examination_desc: e.target.value })
                            }}
                            helperText={
                                ""
                            }
                            disabled={false}
                            multiline
                            minRow={6}
                            inputHeight={'auto'}
                        />
                    </Grid>
                    <Grid
                        item
                        xs={12}
                        md={12}
                        lg={3}
                        sx={{
                            alignSelf: "end",
                        }}
                    >
                        <InputDatePicker required heading={t('วันที่เริ่มต้นกิจกรรม')} value={form?.examination_start_date || ''}
                            onChange={(e: any) => {
                                setForm({ ...form, examination_start_date: moment(e).format('YYYY-MM-DD') })
                            }} />
                    </Grid>
                    <Grid
                        item
                        xs={12}
                        md={12}
                        lg={3}
                        sx={{
                            alignSelf: "end",
                        }}
                    >
                        <InputDatePicker required disableStartDate={form?.examination_start_date} disabled={!form?.examination_start_date} heading={t('วันที่สิ้นสุดกิจกรรม')} value={form?.examination_end_date || ''}
                            onChange={(e: any) => {
                                setForm({ ...form, examination_end_date: moment(e).format('YYYY-MM-DD') })
                            }} />
                    </Grid>
                    <Grid
                        item
                        xs={12}
                        md={12}
                        lg={3}
                        sx={{
                            alignSelf: "end",
                        }}
                    > <TimePickerCustom
                            required
                            heading={t('เวลาเริ่มต้นกิจกรรม')}
                            placeholder={t('เวลาเริ่มต้นกิจกรรม')}
                            value={form?.examination_start_time || ''}
                            onChange={(e) => {
                                setForm({ ...form, examination_start_time: e })
                            }}
                            helperText={
                                ""
                            }
                            disabled={false}
                        />
                    </Grid>
                    <Grid
                        item
                        xs={12}
                        md={12}
                        lg={3}
                        sx={{
                            alignSelf: "end",
                        }}
                    > <TimePickerCustom
                            heading={t('เวลาสิ้นสุดกิจกรรม')}
                            placeholder={t('เวลาสิ้นสุดกิจกรรม')}
                            required
                            value={form?.examination_end_time || ''}
                            onChange={(e) => {
                                setForm({ ...form, examination_end_time: e })
                            }}
                            helperText={
                                ""
                            }
                            disabled={false}
                        />
                    </Grid>

                    <Grid
                        item
                        xs={12}
                        md={12}
                        lg={6}
                        sx={{
                            alignSelf: "end",
                        }}
                    >
                        <InputDatePicker heading={t('วันที่เริ่มต้นการเปิดจอง')} value={form?.examination_calendar_start_date || ''}
                            onChange={(e: any) => {
                                setForm({ ...form, examination_calendar_start_date: moment(e).format('YYYY-MM-DD') })
                            }} />


                    </Grid>
                    <Grid
                        item
                        xs={12}
                        md={12}
                        lg={6}
                        sx={{
                            alignSelf: "end",
                        }}
                    >
                        <InputDatePicker heading={t('วันที่สิ้นสุดการเปิดจอง')} disabled={!form?.examination_calendar_start_date} disableStartDate={form?.examination_calendar_start_date} value={form?.examination_calendar_end_date || ''}
                            onChange={(e: any) => {
                                setForm({ ...form, examination_calendar_end_date: moment(e).format('YYYY-MM-DD') })
                            }} />

                    </Grid>


                </Grid>

                <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginTop: '20px' }}>
                    <Typography variant='h6'>{t("ไฟล์แนบ")}</Typography>
                    <AddSquare onClick={() => setForm({ ...form, id_examination_calendar_files: form?.id_examination_calendar_files?.length > 0 ? [...form?.id_examination_calendar_files, {}] : [{}] })} />
                </div>
                {(form?.id_examination_calendar_files as any[])?.map((item: any, index: number) => {
                    const base_api_img = `${api_img}${item?.file_path}${item?.file_name}`;
                    return (
                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginTop: '10px', width: "100%" }}>
                            <UploadFile
                                onDrop={(file) => {
                                    handleChangeFile(index, file)
                                }}
                                fileAttachmentId={item?.id_examination_calendar_file ?? undefined}
                                fileAttachmentName={item?.file_name ?? undefined}
                                customViewButtonWithPath={item?.id_examination_calendar_file ? base_api_img ?? "" : undefined}
                                viewButtonWithPath={item?.id_examination_calendar_file ? base_api_img ?? "" : undefined}
                                onDownloadFile={() => handleDownloadFile(item?.id_examination_calendar_file, item?.file_name, item?.file_type)}
                                file={item?.file}
                                // enableFormatImage
                                onDeleteFileId={() => {
                                    // ลบไฟล์เดิม (มี id) => ไม่ส่ง id ตอน submit server จะลบให้
                                    handleRemoveFile(index)
                                }}
                                onDeleteFile={() => {
                                    // ลบไฟล์ใหม่ที่ยังไม่อัปโหลด => เอาออกจากรายการเฉยๆ
                                    handleRemoveFile(index)
                                }}
                                noClick={false}
                            // formatText='ขนาดไม่เกิน 10MB'
                            // customFormat={["image/jpeg", "image/jpg", "image/png"]}

                            />
                        </div>
                    )
                })}
            </section>


            <section className="col-span-12 flex items-center justify-center gap-4 my-4">
                <ButtonOutlined
                    onClick={() => {
                        // navigate(routeName.cms.MeetingCalendar);
                        navigate(routeName.cms.ScheduleCalenda);
                    }}
                    buttonName={t("ย้อนกลับ")}
                    btnProps={{
                        width: "150px",
                    }}
                />


                {mode !== 'VIEW' && <ButtonPrimary
                    onClick={() => {
                        // handleSubmit(inputValueFormStudent.information);
                        handleSubmit('DRAFT')
                    }}
                    disabled={disabled_draft_button}
                    mode="success"
                    buttonName={t("บันทึกร่าง", { context: "action" })}
                    btnProps={{
                        width: "150px",
                        bg: "#2186E3"
                    }}
                />}

                {mode !== 'VIEW' && <ButtonPrimary
                    onClick={() => {
                        // handleSubmit(inputValueFormStudent.information);
                        // handleSubmit('WAITING_OPEN')
                        handleSubmit('OPEN')
                    }}
                    disabled={disabled_submit_button}
                    mode="success"
                    buttonName={t("ยืนยัน")}
                    btnProps={{
                        width: "150px",
                    }}
                />}
            </section>
        </div>
    )
}
